module.exports = __webpack_public_path__ + "img/first_place.818c9714.png";